import { render, staticRenderFns } from "./Recursion.vue?vue&type=template&id=4c39f2f6&"
import script from "./Recursion.vue?vue&type=script&lang=js&"
export * from "./Recursion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports